import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import styles from './signup.module.css';
import NavHeader from './NavHeader';
import Notification from '../shared/Notification';

const Signup = () => {
    const [formData, setFormData] = useState({
        emailOrPhone: '',
        password: '',
        name: ''
    });
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const [notification, setNotification] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        setError('Sending verification email...');
        e.preventDefault();
        try {
            const response = await axios.post('/api/authApplicant/signup', formData);
            // console.log(response.data);
            setError(response.data.message);
            sessionStorage.setItem('verifyEmailOrPhone',formData.emailOrPhone);
            navigate('/verify');
        } catch (error) {
            if (error.response && error.response.data) {
                setNotification(error.response.data.message);
                setError(error.response.data.message);
            } else {
                setNotification('An error occurred. Please try again.');
            }
            // console.error(error);
        }
    };
     const handleCloseNotification = () => {
        setNotification('');
    };

    return (
        <>
        <NavHeader/>
        {notification && (
            <Notification message={notification} onClose={handleCloseNotification} />
        )}
        <div className={styles.signupContainer}>
            <form onSubmit={handleSubmit} className={styles.signupForm}>
                <h2>Signup</h2>
                <div className={styles.enterPasswordContainer}>
                    <input
                        type="text"
                        name="emailOrPhone"
                        placeholder="Email or Phone(country code needed)"
                        value={formData.emailOrPhone}
                        className={styles.emailOrPhoneInput}
                        onChange={handleChange}
                        required
                    />
                    <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Password"
                        value={formData.password}
                        className={styles.passwordInput}
                        onChange={handleChange}
                        required
                    />
                    <span 
                        onClick={() => setShowPassword(!showPassword)}
                        className={styles.eyeIcon}
                    >
                    {showPassword ? '👁️' : '👁️‍🗨️'}
                    </span>
                    <input
                        type="text"
                        name="name"
                        placeholder="Name"
                        value={formData.name}
                        className={styles.nameInput}
                        onChange={handleChange}
                        required
                    />
                </div>
                {error && <p className={styles.error}>{error}</p>}
                <button type="submit" >Signup</button>
                <p>Already have an account? <a href="/login">Login</a></p>

            </form>
        </div>
        </>
    );
};

export default Signup;